import moveFocusToNextFocusableElementOnDeletion from '../../utilities/move_focus_to_next_focusable_element_on_deletion';

export class PhxDeleteConfirmationController {
  onDelete: () => void;
  onConfirm: () => void;
  showConfirmation = false;

  constructor(
    private $element: ng.IRootElementService,
    private $scope: ng.IScope,
    private $timeout: ng.ITimeoutService,
    private $document: ng.IDocumentService
  ) {
    this.onDelete = () => {
      this.toggleShowConfirmation();
      this.onConfirm();
      moveFocusToNextFocusableElementOnDeletion();
    };

    const onClickAway = (event: JQueryEventObject) => {
      const isInParent: boolean = $element.parent()[0].contains(event.target);

      if (!isInParent && this.showConfirmation) {
        this.toggleShowConfirmation();
      }

      $scope.$digest();
    };

    $timeout(() => {
      $document.bind('mouseup', onClickAway);
    });

    $scope.$on('destroy', () => {
      $document.unbind('mouseup');
    });
  }

  toggleShowConfirmation() {
    this.$element.parent().toggleClass('delete-confirmation');
    this.showConfirmation = !this.showConfirmation;
  }
}

angular
  .module('capability-ng-global')
  .controller('ngPhxDeleteConfirmationController', PhxDeleteConfirmationController)
  .component('phxDeleteConfirmation', {
    controller: 'ngPhxDeleteConfirmationController',
    templateUrl: 'lib/global/components/delete_confirmation/delete_confirmation.html',
    controllerAs: '$ctrl',
    bindings: {
      onConfirm: '&',
      label: '@?'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/global/components/delete_confirmation/delete_confirmation.ts